{
  "title": "Goods Receipt Note (GRN)",
  "subtitle": "Record inbound receipts against purchase orders and post them into the QC / Putaway pipeline.",
  "add": "New GRN",
  "view": "View",
  "edit": "Edit",
  "save": "Save",
  "table": {
    "number": "GRN Number",
    "supplier": "Supplier",
    "warehouse": "Warehouse",
    "date": "GRN Date",
    "lines": "Lines",
    "status": "Status",
    "actions": "Actions",
    "material": "Material",
    "orderedQty": "Ordered Qty",
    "expiryDate": "Expiry Date",
    "qcStatus": "QC Status",
    "client": "Client"
  },
  "form": {
    "linkedGateEntry": "From Gate Entry (optional)",
    "linkedPO": "From Purchase Order (optional)",
    "none": "None",
    "supplier": "Supplier",
    "warehouse": "Warehouse",
    "client": "Client",
    "vehicleNo": "Vehicle No",
    "inwardDocNo": "Inward Doc No",
    "reconciliation": "Material Receipt",
    "material": "Material",
    "received": "Received Qty",
    "accepted": "Accepted Qty",
    "rejected": "Rejected Qty",
    "batchNo": "Batch No",
    "unitPrice": "Unit Price",
    "addLine": "Add Line",
    "generate": "GRN Generate"
  },
  "cancel": "Cancel"
}
